import React from 'react'

import PropTypes from 'prop-types'

import './processo-reverso-duplo.css'

const ProcessoReversoDuplo = (props) => {
  return (
    <div
      className={`processo-reverso-duplo-container1 ${props.rootClassName} `}
    >
      <div className="processo-reverso-duplo-container2">
        <div className="processo-reverso-duplo-container3">
          <span className="processo-reverso-duplo-text1">
            {props.tituloPrimeiro}
          </span>
          <span className="processo-reverso-duplo-text2 Content">
            {props.textoPrimeiro}
          </span>
        </div>
        <div className="processo-reverso-duplo-container4">
          <span className="processo-reverso-duplo-text3">
            {props.tituloSegundo}
          </span>
          <span className="processo-reverso-duplo-text4 Content">
            {props.textoSegundo}
          </span>
        </div>
      </div>
      <img
        alt={props.imageAlt}
        src={props.imageSrc}
        loading="eager"
        className="processo-reverso-duplo-image"
      />
    </div>
  )
}

ProcessoReversoDuplo.defaultProps = {
  textoSegundo: 'Text',
  tituloSegundo: 'Title',
  tituloPrimeiro: 'Title',
  imageAlt: 'image',
  textoPrimeiro: 'Text',
  imageSrc: 'https://play.teleporthq.io/static/svg/default-img.svg',
  rootClassName: '',
}

ProcessoReversoDuplo.propTypes = {
  textoSegundo: PropTypes.string,
  tituloSegundo: PropTypes.string,
  tituloPrimeiro: PropTypes.string,
  imageAlt: PropTypes.string,
  textoPrimeiro: PropTypes.string,
  imageSrc: PropTypes.string,
  rootClassName: PropTypes.string,
}

export default ProcessoReversoDuplo
